var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",attrs:{"id":"app"}},[_c('Navbar'),_c('router-view'),_vm._l((10),function(index){return _c('br',{key:index})}),_c('div',{staticClass:"wrapper"},[_c('Footer')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }